import { z } from "zod";
export const playingPaceSchema = z.enum([
  "relaxed",
  "steady",
  "brisk",
  "unknown",
]);
export type PlayingPace = z.infer<typeof playingPaceSchema>;
export const playTogetherDurationSchema = z.enum([
  "first_session",
  "every_session",
]);
export type PlayTogetherDuration = z.infer<typeof playTogetherDurationSchema>;
export const PACE_QUESTION = "What pace of play feels most comfortable to you?";
export const PACE_HELPER = "This is about your preferred pace, not your experience or skill level.";
export const PACE_OPTIONS = [
  {
    value: "relaxed",
    label: "Relaxed",
    description: "I enjoy a little more time to consider my plays.",
  },
  {
    value: "steady",
    label: "Steady",
    description: "I’m comfortable keeping the game moving at a consistent pace.",
  },
  {
    value: "brisk",
    label: "Quick",
    description: "I enjoy a faster-moving game.",
  },
  {
    value: "unknown",
    label: "Not sure yet",
    description: "I’m still finding the pace that feels right for me.",
  },
] as const;
export const DURATION_OPTIONS = [
  {
    value: "first_session",
    label: "First session only",
    description: "We’d like to sit together for the first session.",
  },
  {
    value: "every_session",
    label: "Every session",
    description: "We’d like to sit together throughout the league.",
  },
] as const;
export function paceLabel(pace?: PlayingPace | null) {
  return PACE_OPTIONS.find((p) => p.value === pace)?.label ?? "Not sure yet";
}
export function effectivePace(
  preference?: PlayingPace | null,
  override?: PlayingPace | null,
): PlayingPace {
  return override ?? preference ?? "unknown";
}
export function requestApplies(
  duration: PlayTogetherDuration,
  session: number,
) {
  return duration === "every_session" || session === 1;
}
